/**
 * Dawn's SliderComponent computes slider-counter--total as a "page count"
 * (visible-slides-per-view based), not the actual item count, so a 3-block
 * peek slider often shows "1 / 4" instead of "1 / 3". We want the real
 * block count here, so we pin the total back to data-true-total whenever
 * Dawn's own update() overwrites it.
 */
document.querySelectorAll('.slider-counter--total[data-true-total]').forEach(function (el) {
  var trueTotal = el.getAttribute('data-true-total');
  el.textContent = trueTotal;
  new MutationObserver(function () {
    if (el.textContent !== trueTotal) el.textContent = trueTotal;
  }).observe(el, { childList: true, characterData: true, subtree: true });
});
